import { useState } from 'react'

const STATUS_COLORS = {
  in_behandeling: { bg: '#fef3c7', color: '#92400e', border: '#fde68a' },
  geaccepteerd: { bg: '#dcfce7', color: '#166534', border: '#86efac' },
  geweigerd: { bg: '#fee2e2', color: '#991b1b', border: '#fca5a5' },
  geannuleerd: { bg: '#f3f4f6', color: '#6b7280', border: '#d1d5db' },
  niet_verschenen: { bg: '#fef3c7', color: '#92400e', border: '#fde68a' },
}

const STATUS_LABELS = {
  in_behandeling: 'In behandeling',
  geaccepteerd: 'Geaccepteerd ✅',
  geweigerd: 'Geweigerd',
  geannuleerd: 'Geannuleerd',
  niet_verschenen: 'Niet verschenen',
}

const BookingCard = ({ booking, onCancel }) => {
  const [showCancel, setShowCancel] = useState(false)
  const status = STATUS_COLORS[booking.status] || STATUS_COLORS.in_behandeling
  const charger = booking.chargers
  const canCancel = ['in_behandeling', 'geaccepteerd'].includes(booking.status)

  return (
    <div style={{
      background: 'white',
      borderRadius: 16,
      padding: 16,
      border: '1px solid var(--cream-dark)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
    }}>

      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 10
      }}>
        <div style={{ flex: 1, marginRight: 10 }}>
          <div style={{
            fontFamily: 'Fraunces, serif',
            fontSize: 15,
            fontWeight: 900,
            color: 'var(--ink)',
            marginBottom: 2
          }}>
            {charger?.name}
          </div>
          <div style={{ color: 'var(--ink-muted)', fontSize: 12 }}>
            📍 {charger?.address}, {charger?.city}
          </div>
        </div>
        <span style={{
          background: status.bg,
          color: status.color,
          border: `1px solid ${status.border}`,
          borderRadius: 20,
          padding: '3px 10px',
          fontSize: 11,
          fontWeight: 700,
          whiteSpace: 'nowrap',
          flexShrink: 0
        }}>
          {STATUS_LABELS[booking.status]}
        </span>
      </div>

      {/* Booking details */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 8,
        marginBottom: 10
      }}>
        {[
          { label: 'Datum', value: booking.date },
          { label: 'Tijd', value: `${booking.start_time?.slice(0, 5)} – ${booking.end_time?.slice(0, 5)}` },
          { label: 'Duur', value: `${booking.duration_hours}u` },
          { label: 'Geschat', value: `€${booking.total_price_est}` },
        ].map(({ label, value }) => (
          <div key={label} style={{
            background: 'var(--cream)',
            borderRadius: 10,
            padding: '8px 12px'
          }}>
            <div style={{ fontSize: 10, color: 'var(--ink-muted)', fontWeight: 600, marginBottom: 2 }}>
              {label}
            </div>
            <div style={{ fontSize: 13, color: 'var(--ink)', fontWeight: 700 }}>
              {value}
            </div>
          </div>
        ))}
      </div>

      {/* Driver message */}
      {booking.driver_message && (
        <div style={{
          background: 'var(--cream)',
          borderRadius: 10,
          padding: '8px 12px',
          marginBottom: 10,
          fontSize: 12,
          color: 'var(--ink-soft)',
          fontStyle: 'italic'
        }}>
          "{booking.driver_message}"
        </div>
      )}

      {/* Owner response */}
      {booking.owner_response && (
        <div style={{
          background: 'var(--green-pale)',
          border: '1px solid var(--green-mid)',
          borderRadius: 10,
          padding: '8px 12px',
          marginBottom: 10,
          fontSize: 12,
          color: 'var(--ink-soft)'
        }}>
          <span style={{ fontWeight: 700, color: 'var(--green)' }}>Eigenaar: </span>
          {booking.owner_response}
        </div>
      )}

      {/* Cancel button */}
      {canCancel && (
        <>
          {showCancel ? (
            <div style={{
              background: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: 12,
              padding: 12
            }}>
              <div style={{ fontSize: 13, color: 'var(--ink)', marginBottom: 10, fontWeight: 600 }}>
                Weet je zeker dat je wilt annuleren?
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  onClick={() => setShowCancel(false)}
                  style={{
                    flex: 1, padding: '9px', borderRadius: 10,
                    border: '1px solid var(--cream-dark)', background: 'white',
                    color: 'var(--ink-muted)', fontWeight: 600, cursor: 'pointer',
                    fontSize: 13, fontFamily: 'DM Sans, sans-serif'
                  }}>
                  Nee, terug
                </button>
                <button
                  onClick={() => onCancel(booking.id)}
                  style={{
                    flex: 1, padding: '9px', borderRadius: 10,
                    border: 'none', background: 'var(--red)',
                    color: 'white', fontWeight: 700, cursor: 'pointer',
                    fontSize: 13, fontFamily: 'DM Sans, sans-serif'
                  }}>
                  Ja, annuleer
                </button>
              </div>
            </div>
          ) : (
            <button
              onClick={() => setShowCancel(true)}
              style={{
                width: '100%', padding: '9px', borderRadius: 10,
                border: '1px solid #fecaca', background: 'transparent',
                color: 'var(--red)', fontWeight: 600, cursor: 'pointer',
                fontSize: 13, fontFamily: 'DM Sans, sans-serif'
              }}>
              Annuleren
            </button>
          )}
        </>
      )}
    </div>
  )
}

export default BookingCard
